<template>
  <el-tabs class="produce" v-model="activeName">
    <el-tab-pane label="季度产量" name="production">
      <production v-if="activeName == 'production'"/>
    </el-tab-pane>
    <el-tab-pane label="产能负荷" name="load">
      <load v-if="activeName =='load'" />
    </el-tab-pane>
    <el-tab-pane label="产品良品率" name="yields">
      <yields v-if="activeName =='yields'" />
    </el-tab-pane>
    <el-tab-pane label="单位产品能耗趋势" name="tendency">
      <tendency v-if="activeName =='tendency'" />
    </el-tab-pane>

    <el-tab-pane label="实时状态" name="timestatus">
      <timestatus v-if="activeName =='timestatus'" />
    </el-tab-pane>
    <el-tab-pane label="自动化产线" name="autoline">
      <autoline v-if="activeName =='autoline'" />
    </el-tab-pane>
    <el-tab-pane label="订单进度" name="schedule">
      <schedule v-if="activeName =='schedule'" />
    </el-tab-pane>
    <el-tab-pane label="最近订单" name="recentorder">
      <recentorder v-if="activeName =='recentorder'" />
    </el-tab-pane>
    <el-tab-pane label="产能趋势" name="capacity">
      <capacity v-if="activeName =='capacity'" />
    </el-tab-pane>
    <el-tab-pane label="生产提示" name="hint">
      <hint v-if="activeName =='hint'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import production from './production'
import load from './load'
import yields from './yields'
import timestatus from './timestatus'
import tendency from './tendency'
import schedule from './schedule'
import recentorder from './recentorder'
import hint from './hint'
import autoline from './autoline'
import capacity from './capacity'


export default {
  components: {
    production,
    load,
    yields,
    timestatus,
    tendency,
    schedule,
    recentorder,
    hint,
    autoline,
    capacity,
  },
  data() {
    return {
      activeName: 'production',

    }
  },
  mounted() {},
  methods: {

  },
}
</script>

<style lang="less">
.produce { height: 100%; overflow-y: auto;
  .avatar,.avatar-uploader{ width: 8rem; height: 6rem; border: #3570ff solid 1px;}
  .avatar-uploader{ color: #fff; text-align:center; line-height: 6rem; font-size: 2rem;}
}
</style>